module.exports = __webpack_public_path__ + "static/media/linkedin_logo.f08c524d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/linkedin_logo.png
// module id = 60
// module chunks = 0